const PREFIX = "toing-lpg";

export const TOING_HEADER_BANNER_TEST_IDS = {
    ROOT: `${PREFIX}-banner-root`,
    TITLE: `${PREFIX}-banner-title`,
    SUBTITLE: `${PREFIX}-banner-subtitle`,
    SAVINGS_CALLOUT: `${PREFIX}-banner-savings-callout`,
};

export const TOING_POPUP_TEST_IDS = {
    CONTAINER: `${PREFIX}-popup-container`,
    CTA: `${PREFIX}-popup-cta`,
    CLOSE: `${PREFIX}-popup-close`,
    IMAGE: `${PREFIX}-popup-image`,
};

export const TOING_SAVINGS_BANNER_TEST_IDS = {
    WRAPPER: `${PREFIX}-savings-banner`,
};

export const TOING_FLOATING_BUTTON_TEST_IDS = {
    WRAPPER: `${PREFIX}-floating-button`,
};

export const TOING_PC_TEST_IDS = {
    CONTAINER: "toing-pc-container",
    CLOSE_BUTTON: "toing-pc-close-btn",
    UPLOAD_CTA: "toing-pc-upload-cta",
    UPLOAD_AGAIN_CTA: "toing-pc-upload-again-cta",
    TITLE: "toing-pc-title",
    SUBTITLE: "toing-pc-subtitle",
    LOTTIE: "toing-pc-lottie",
    FREE_CASH_AMOUNT: "toing-pc-free-cash",
    BILL_AMOUNT: "toing-pc-bill-amount",
    ERROR_CONTAINER: "toing-pc-error-container",
    ERROR_TITLE: "toing-pc-error-title",
    ERROR_SUBTITLE: "toing-pc-error-subtitle",
    GOT_IT_CTA_BUTTON: "toing-pc-got-it-cta",
} as const;
